export default __webpack_public_path__ + "static/media/kansas.ca955500.jpg";